const styles = (theme) => ({
  paper: {
    boxShadow: 'none',
    overflow: 'auto',
  },
  listbox: {
    padding: 0,
  },
  optionContainer: {
    display: 'flex',
    alignItems: 'center',
    '& >:first-child': {
      marginRight: theme.spacing(1),
    },
  },
  option: {
    padding: theme.spacing(1, 0),
    backgroundColor: 'transparent !important',
    '&[aria-selected="true"]': {
      backgroundColor: 'transparent !important',
      color: theme.palette.secondary.main
    },
    '&[data-focus="true"]': {
      backgroundColor: 'transparent !important',
      color: theme.palette.secondary.main
    },
    '&:active': {
      backgroundColor: 'transparent !important',
      color: theme.palette.secondary.main
    },
  },
});

export default styles;
